// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ListChevronsUpDown as RawListChevronsUpDown } from "lucide-react";
export const ListChevronsUpDown = /* @__PURE__ */ createIcon(RawListChevronsUpDown, "ListChevronsUpDown", 2);
